import React from "react";

function TermsCondition() {
  const styles = {
    terms: {
      lineHeight: 1.6,
      backgroundColor: "#FEF4D3",
      overflowX: "hidden", // ✅ Prevent horizontal scroll
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      paddingTop: "34px",
      paddingBottom: "30px",
      wordWrap: "break-word", // ✅ Wrap long text
      overflowWrap: "break-word",
    },
    termsHeader: {
      backgroundColor: "#4f8866",
      color: "white",
      padding: "1.5rem 0",
      textAlign: "center",
      fontSize: "2.5rem",
      marginBottom: "2rem",
      borderRadius: "4px",
    },
    termsContainer: {
      padding: "2rem",
      backgroundColor: "white",
      borderRadius: "8px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    heading: {
      fontSize: "1.5rem",
      marginTop: "1.5rem",
      marginBottom: "1rem",
      color: "#333",
    },
    paragraph: {
      fontSize: "1rem",
      marginBottom: "1rem",
      color: "#444",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal",
    },
    orderedList: {
      paddingLeft: "20px",
      marginBottom: "1rem",
    },
    listItem: {
      marginBottom: "10px",
      wordWrap: "break-word",
      overflowWrap: "break-word",
    },
    link: {
      color: "#2E7D4F",
      textDecoration: "none",
      wordBreak: "break-word",
    },
    nestedList: {
      paddingLeft: "30px",
      marginTop: "10px",
    },
  };

  return (
    <main style={styles.terms}>
      <div style={styles.container}>
        <h1 style={styles.termsHeader}>Terms & Conditions</h1>
        <div style={styles.termsContainer}>
          <p style={styles.paragraph}>
            Please read these terms and conditions carefully before accessing or
            using the Platform (defined hereinafter). These Terms along with the
            Privacy Policy published on the Platform ("Privacy Policy") and
            other policies (as may be notified/displayed/published on the
            Platform) constitute the contract between the Users of this Platform
            and the Company (collectively "Agreement"). By use of the Platform,
            Users agree to be bound by these Agreement as posted on the Platform
            from time to time.
          </p>

          <h2 style={styles.heading}>About the Terms</h2>
          <ol style={styles.orderedList}>
            <li style={styles.listItem}>
              MyTamilKart is an application which provides an online marketplace
              ("Application") where registered Users can send Greeting cards and
              Gifts to anyone within India.
            </li>
            <li style={styles.listItem}>
              The Application and the website www.mytamilkart.com ("Website")
              (collectively, "Platform") are operated by GeDre Technology
              Solutions ("Company").
            </li>
            <li style={styles.listItem}>
              The Company's role is limited to managing the Application and
              associated marketing, facilitating payment collections,
              fulfilment, order management, enquiry management and other
              incidental services to enable the transactions for Users
              ("Services").
            </li>
          </ol>

          <h2 style={styles.heading}>USE OF THE PLATFORM</h2>
          <p style={styles.paragraph}>
            Can users access and use the Platform at any time or could there be
            any limitations?
          </p>
          <ol style={styles.orderedList}>
            <li style={styles.listItem}>
              Company strives to make the App available 24X7. However, the
              Company does not represent that access to the App will be
              uninterrupted, timely, error free, free of viruses or other
              harmful components or that such defects will be corrected.
            </li>
            <li style={styles.listItem}>
              Users acknowledge that the use of Application requires internet
              connectivity and telecommunication links. Users shall bear the
              costs incurred to access and use the Application and avail
              Services, and Company shall not, under any circumstances
              whatsoever, be responsible or liable for such costs.
            </li>
          </ol>

          <h2 style={styles.heading}>FAIR USAGE POLICY</h2>
          <p style={styles.paragraph}>
            We always strive hard to provide the best experience to Our Users on
            the Platform in the best manner and aim to provide liberal customer
            friendly policies. To ensure that all Users use Our Platform in good
            faith, we keep track of user-behaviour which includes maintaining
            order history and other details relating to the manner of use of the
            Platform by the Users.
          </p>

          <h2 style={styles.heading}>
            INTELLECTUAL PROPERTY (IP) AND IP INFRINGEMENT
          </h2>
          <ol style={styles.orderedList}>
            <li style={styles.listItem}>
              Users may not use any trademark, service mark or logo of any
              independent third parties without prior written approval from such
              parties.
            </li>
            <li style={styles.listItem}>
              "MyTamilKart" and related icons and logos whether registered or
              unregistered are the trademarks of the Company and are protected
              under applicable copyright, trademark and other proprietary and
              intellectual property laws.
            </li>
          </ol>

          <h2 style={styles.heading}>COMMUNICATION</h2>
          <p style={styles.paragraph}>
            How to contact Company in case of any queries regarding this
            Agreement or grievances relating to Platform?
          </p>
          <p style={styles.paragraph}>
            All queries, concerns or questions about the Agreement should be
            sent to Company at legal{" "}
          </p>
          <a
            style={styles.link}
            href="https://mail.google.com/mail/?view=cm&to=contact@mytamilkart.in&su=Support%20Request&body=Hello%20Team,"
            target="_blank"
            rel="noopener noreferrer"
          >
            contact@mytamilkart.in
          </a>
        </div>
      </div>

      {/* ✅ Responsive media queries */}
      <style jsx>{`
        @media (max-width: 768px) {
          h1 {
            font-size: 1.8rem !important;
          }
          h2 {
            font-size: 1.3rem !important;
          }
          p,
          li {
            font-size: 0.95rem !important;
          }
          div[style*="padding-top: 170px"] {
            padding-top: 120px !important;
            padding-left: 15px !important;
            padding-right: 15px !important;
          }
        }

        @media (max-width: 480px) {
          h1 {
            font-size: 1.5rem !important;
          }
          h2 {
            font-size: 1.1rem !important;
          }
          p,
          li {
            font-size: 0.9rem !important;
          }
          div[style*="padding-top: 120px"] {
            padding-top: 90px !important;
            padding-left: 10px !important;
            padding-right: 10px !important;
          }
        }
      `}</style>
    </main>
  );
}

export default TermsCondition;
